﻿import googleAdsEvent from './redux/actions';

require('./redux/beaconMiddleware');

export default googleAdsEvent;
